import { Route, Routes } from "react-router-dom";

import SpecificComponent from "@/components/dashboard/components";
import useTitle from "@/hooks/useTitle";

export default function Main() {
  useTitle("Termitool");

  return (
    <Routes>
      <Route path="/*" element={<SpecificComponent />} />
    </Routes>
  );
}
